import { skills } from '../constants/constants';
import { styles } from '../styles';
import { motion } from "framer-motion";
import SkillBar from "./SkillBar";
import ToolTile from "./ToolTile";

const Skills = () => {
    return (
        <motion.section id="skills" className="text-left px-10 py-10 md:container bg-black">
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 20 }}
                transition={{ duration: 0.8 }}
            >
                <h2 className={styles.sectionHeadText}>
                    {skills.heading}
                </h2>

                <p className="text-xl font-medium">
                    {skills.text}
                </p>

                <div className="my-10">
                    <h3 className="text-2xl font-semibold mb-4">
                        Programming languages
                    </h3>

                    <div className="text-xs md:text-base lg:text-lg leading-[30px] md:leading-[50px]">
                        {skills.technologies.map((skill, index) => (
                            <SkillBar key={skill.name} {...skill} index={index} />
                        ))}
                    </div>
                </div>

                <div className="my-16">
                    <h3 className="text-2xl font-semibold mb-6">
                        Tooling & Other
                    </h3>

                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {skills.tools.map((tool) => (
                            <ToolTile key={tool.name} {...tool} />
                        ))}
                    </div>
                </div>
            </motion.div>
        </motion.section>
    );
};

export default Skills;